import { StaticImage } from "gatsby-plugin-image"
import React from "react"

const Social3D = () => {
  return (
    <p className='flex space-x-5 justify-center items-center social-3d'>
      <a
        href='https://www.facebook.com/pages/category/casino/Quick-Hit-Slots-Community-1514614155455091/'
        target='_blank'
      >
        <StaticImage src='../images/social-3d/facebook.png' alt='' width={70} />
      </a>
      <a href='https://www.instagram.com/quickhitslots/' target='_blank'>
        <StaticImage
          src='../images/social-3d/instagram.png'
          alt=''
          width={70}
        />
      </a>
      <a href='https://twitter.com/QuickHitSlots' target='_blank'>
        <StaticImage src='../images/social-3d/twitter.png' alt='' width={70} />
      </a>
      <a
        href='https://www.youtube.com/channel/UCMy17pGosYA-POoOXaTrP7A'
        target='_blank'
      >
        <StaticImage src='../images/social-3d/youtube.png' alt='' width={70} />
      </a>
    </p>
  )
}

export default Social3D
